type SizeUnit = `${number}${'px' | 'em' | 'rem'}`
interface ISpinnerProps {
  color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'
  type?: 'border' | 'grow'
  size?: SizeUnit | number
}

export const Spinner = ({color = 'primary', type = 'border', size = '40px'}: ISpinnerProps) => {
  return (
    <div
      className={`spinner-${type} text-${color}`}
      role='status'
      style={{height: size, width: size}}
    >
      <span className='visually-hidden'>Loading...</span>
    </div>
  )
}
